import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { numberWithComma, formatDateWithoutTime } from 'helpers/format'
import { Col, Row, Space } from 'antd'
import { PaymentData } from 'Store/grn-payment/types'
import PdfCompanyInfo from 'Pages/Purchase/components/PdfCompanyInfo'
import { PdfPrintFormat, PdfPrintLiteFormat } from 'Components/form'

type Props = {
  detail?: PaymentData
  isLite?: boolean
}

const InvoicePDF: React.FunctionComponent<Props> = props => {
  const { detail, isLite = false } = props

  const renderInfo = (val: any) => {
    return <RowTile>{val}</RowTile>
  }

  const renderInfoItem = (title: any, value: any, justify: 'start' | 'end' = 'start') => {
    return (
      <Row gutter={[8, 8]} justify={justify}>
        <Col>
          <Space wrap={true}>
            <InfoTitle>
              {title} : {value || '-'}
            </InfoTitle>
          </Space>
        </Col>
      </Row>
    )
  }

  const renderSupplierInfo = () => {
    const supplier = detail?.supplier
    return (
      <div>
        {renderInfoItem('ผู้จำหน่าย', supplier?.supplier_code)}
        {renderInfoItem('บริษัท', supplier?.name)}
        {renderInfoItem('ที่อยู่', supplier?.address)}
        {renderInfoItem('เบอร์โทรศัพท์', supplier?.mobile_no)}
      </div>
    )
  }

  const renderPurchaseInfo = () => {
    return (
      <div>
        {renderInfoItem('เลขที่', detail?.payment_no, 'end')}
        {renderInfoItem('วันที่ชำระ', formatDateWithoutTime(detail?.payment_date || ''), 'end')}
        {renderInfoItem('ผู้ทำรายการ', detail?.username, 'end')}
      </div>
    )
  }

  const summaryFooter = (
    <Row justify="end">
      {/* <Col>
      <TotalPrice>
        ประเภทการชำระ {detail?.type === 'installment' ? 'ชำระบางส่วน' : 'ชำระเต็มจำนวน'}{' '}
      </TotalPrice>
    </Col> */}
      <Col>
        <TotalPrice> ยอดที่ชำระทั้งสิ้น {numberWithComma(detail?.total_price || 0, true)} บาท</TotalPrice>
      </Col>
    </Row>
  )

  const tableHeader = (
    <thead>
      <th className="left">เลขที่ใบจ่ายหนี้</th>
      <th>วันที่รับเข้าคลัง</th>
      <th className="right">ยอดที่ชำระ</th>
    </thead>
  )

  const tableBody = (
    <tbody>
      {(detail?.payment_items || []).map((item, index) => {
        return (
          <tr key={index}>
            <td className="left">{renderInfo(item?.grns.grn_no || '-')}</td>
            <td>{renderInfo(formatDateWithoutTime(item?.grns.recieved_date || ''))}</td>
            <td className="right">{renderInfo(numberWithComma(item?.price || 0, true))}</td>
          </tr>
        )
      })}
    </tbody>
  )

  return isLite ? (
    <PdfPrintLiteFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={'ใบชำระหนี้'}
      leftInfo={renderSupplierInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={8}
      summaryFooter={summaryFooter}
      signPosition={['ผู้รับสินค้า', 'ผู้จ่ายสินค้า']}
      thead={tableHeader}
      tbody={tableBody}
    />
  ) : (
    <PdfPrintFormat
      companyInfo={<PdfCompanyInfo merchant={detail?.merchant} />}
      title={'ใบชำระหนี้'}
      leftInfo={renderSupplierInfo()}
      rightInfo={renderPurchaseInfo()}
      footerSpan={8}
      summaryFooter={summaryFooter}
      signPosition={['ผู้รับสินค้า', 'ผู้จ่ายสินค้า']}
      thead={tableHeader}
      tbody={tableBody}
    />
  )
}

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const InfoTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
`

const TotalPrice = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  padding: 10px 0 10px 0;
  text-align: right;
`

export default InvoicePDF
